import { Layout } from '@/utils/routerHelper'

// Allows a standalone window to reach the dashboard before dynamic menu routes load.
// path 必须与 system_module.config.adminCard.homePath (/microscene/dashboard) 一致
const microSceneRoutes: AppRouteRecordRaw[] = [
  {
    path: '/microscene',
    component: Layout,
    name: 'MicroSceneDirectRoutes',
    meta: { hidden: true },
    children: [
      {
        path: 'dashboard',
        component: () => import('@/views/microscene/dashboard/index.vue'),
        name: 'MicroSceneDashboardDirect',
        meta: { hidden: true, canTo: true, title: '数据中心' }
      },
      {
        path: 'overview',
        component: () => import('@/views/microscene/overview/index.vue'),
        name: 'MicroSceneOverviewDirect',
        meta: { hidden: true, canTo: true, title: '概况' }
      }
    ]
  }
]

export default microSceneRoutes
